export enum FinanceProductNamesTypes {
  CASH = 'CASH'
}
